<template>
    <div class="footer">
        <p>
            <a href="">关于我们</a>
            <!-- <span>|</span>
            <a href="javascript:;" @click="loginReg('login')">用户登录</a>
            <span>|</span>
            <a href="javascript:;" @click="loginReg('reg')">用户注册</a> -->
        </p>
        <p>
            Copyright &copy;  少女计划软件官网 版权所有 违者必究
        </p>
    </div>
</template>

<script>    
    import { mapGetters } from 'vuex';
    export default {
        data() {
            return {
                login_reg_visible: false,
                login_reg_type: ""
            };
        },        
        computed: {
            ...mapGetters(['token'])
        },
        methods: {
            loginReg(type) {
                this.$eventBus.$emit('showLoginReg',type);
            }
        }
    }
</script>

<style lang="scss">
    .footer {        
        width: 100%;
        box-sizing: border-box;
        height: 70px;
        background: #9A681F;
        text-align: center;
        color: #fff;
        padding-top: 10px;
        margin-top: 15px;
        font-size: 12px;
        p {
            line-height: 25px;
        }
        a {
            color: #fff;
        }
        span {
            padding: 0 5px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue